<template>
  <o-panel-link
    :path="`/appointment/${data.idReservation}?date=${data.date}`"
    @mouseenter="handleMouseEnter()"
    @mouseleave="handleMouseLeave()"
  >
    <o-card
      :class="cardClass"
      baseClass="rounded-lg p-2 text-sm"
      bodyClass="p-0"
      actionable
    >
      <div v-if="!privacyMode && single && data.customer" class="mb-2 flex justify-between items-center">
        <span class="font-semibold">{{ data.customer.displayName }}</span>

        <div class="flex items-center space-x-1">
          <labels
            :checked-in="data.checkedIn"
            :status="status"
            :customer="data.customer"
          />
        </div>
      </div>
      <div
        v-for="service in data.services"
        :key="`${data.idReservation}-${service.idReservationService}`"
        class="flex items-center mb-3 last:mb-0"
      >
        <div
          class="self-stretch w-2 mr-2 rounded"
          :style="{
            backgroundColor: '#' + service.service.borderHexColour
          }"
        />
        <div class="flex-shrink-0 opacity-80 font-semibold mr-4">
          <p data-cy="start-time">
            {{ $date.minutes(service.startTime) }}
          </p>
          <p data-cy="finish-time">
            {{ $date.minutes(service.startTime + service.duration) }}
          </p>
        </div>
        <div class="w-full">
          <i18n-t keypath="components.schedule.elements.reservation.with" tag="p" data-cy="title">
            <template #services>
              {{ service.service.title }}
            </template>
            <template v-if="service.employee && service.employee.displayName" #employees>
              {{ service.employee.displayName }}
            </template>
          </i18n-t>
          <p class="text-sm opacity-80 flex flex-wrap">
            <span class="mr-4">
              {{ $t('datetime.increments.mins', { mins: service.duration }, Number(service.duration)) }}
            </span>
            <span v-if="!privacyMode" class="mr-4">
              {{ service.priceLabel }}
            </span>
          </p>
        </div>
      </div>
    </o-card>
  </o-panel-link>
</template>

<script setup lang="ts">
import Labels from '@/components/schedule/elements/Labels.vue'
import { ServiceCustomerType } from '@/_api/models/service'

import { useUIStore } from '~/stores/useUIStore'

const uiStore = useUIStore()

interface Props {
  data: any
  cardClass?: string
}

const props = withDefaults(defineProps<Props>(), {
  cardClass: 'rounded-lg overflow-hidden relative mb-4 py-3 px-3 bg-gray-100 text-gray-800',
})

const emit = defineEmits<{
  (e: 'highlight', value: any): void
  (e: 'focus', value: any): void
}>()

let timer: ReturnType<typeof setTimeout> | null = null

const privacyMode = computed(() => uiStore.privacyMode)

const blocks = computed(() => {
  const idReservation = props.data.idReservation
  const elements = document.getElementsByClassName(`reservation-${idReservation}`)
  const b = [...elements].map(({ id }) => id)

  return b
})

const single = computed(() => props.data.customerType !== ServiceCustomerType.group)

const status = computed(() => {
  return props.data.statusType ? { label: props.data.statusType.name, colour: props.data.statusType.hexColour } : null
})

function handleMouseEnter() {
  timer = setTimeout(() => {
    const b = blocks.value

    highlight(b)
    focus(b)
  }, 1500)
}

function handleMouseLeave() {
  if (timer) clearTimeout(timer)

  highlight(null)
  focus(null)
}

function highlight(val: any) {
  emit('highlight', val)
}

function focus(val: any) {
  emit('focus', val)
}
</script>
